import { render, staticRenderFns } from "./documents-upload-btn.vue?vue&type=template&id=d92eeaca&"
import script from "./documents-upload-btn.vue?vue&type=script&lang=js&"
export * from "./documents-upload-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports